/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Why_SubtitleInputs */

const en_landing_why_subtitle = /** @type {(inputs: Landing_Why_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What Ideogram published at release, and how this workspace runs it.`)
};

const zh_landing_why_subtitle = /** @type {(inputs: Landing_Why_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ideogram 发布时公开的信息，以及本工作台的实现方式。`)
};

/**
* | output |
* | --- |
* | "What Ideogram published at release, and how this workspace runs it." |
*
* @param {Landing_Why_SubtitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_why_subtitle = /** @type {((inputs?: Landing_Why_SubtitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Why_SubtitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_why_subtitle(inputs)
	return zh_landing_why_subtitle(inputs)
});
export { landing_why_subtitle as "landing.why.subtitle" }